export const FILE_PARSE_ENTITIES_CSV = 0;
export const FILE_PARSE_DOCUMENT_HTML = 1;
export const FILE_PARSE_DOCUMENT_TEXT = 2;
//Export Data constants
export const EXPORT_FORMAT_TAGTOG = 0 ;
export const EXPORT_FORMAT_NER = 1 ;
//Anotator settings 
export const ANOTATOR_DEFAULT_TEXT_SIZE = '12';
export const ANNOTATOR_SHOW_RIGHT_CONTEXT= 'RIGHT';
export const ANNOTATOR_SHOW_LEFT_CONTEXT= 'LEFT';

//Tools settings 
export const ANNOTATOR_TOOL_STATUS = 'STATUS';
export const ANNOTATOR_TOOL_STATUS_SHOW = 'SHOW';
export const ANNOTATOR_TOOL_STATUS_HIDDEN = 'HIDDEN';
export const ANNOTATOR_TOOL_DETAILS_HEIGHT = 'DETAILS_TOOL_HEIGHT';
export const ANNOTATOR_TOOL_DEFAULT_HEIGHT = 100;

export const ANNOTATOR_TOOL_LABELS_HEIGHT = 'LABELS_TOOL_HEIGHT';

export const DOCUMENTS_REPLACER = (key: any, value: any ) => (value === null ? '' : value);